// This is the Roc.Web variant of type-assertions.ts
// The contents of this file should be identical to the version living in Roc.Admin
// This currently cannot be moved to Roc.SharedClientApp (shared-client) because of transpilation issues with babel and webpack.
// Working around this issue is currently not viable at this time but may be resolved in the future.
// Please see https://github.com/babel/babel/issues/8309

/**
 * Represents an assertion failure, meaning that an invariant that is supposed to always hold true, failed
 * Assertion failures should never be handled as they should never happen. They represent a programmer error.
 */
export class AssertionError extends Error {
	constructor(m: string) {
		super(m);

		// Set the prototype explicitly.
		Object.setPrototypeOf(this, AssertionError.prototype);
	}
}

/**
 * Asserts that the specified condition is true and throws an assertion error if it is not.
 *
 * This is an assertion function and use of this function will impact TypeScript's flow analysis.
 */
export function assert(condition: any, message: string = ''): asserts condition {
	if (!condition) {
		if (message.length > 0) {
			throw new AssertionError(`Assertion Failure: ${message}`);
		} else {
			throw new AssertionError(`Assertion Failure`);
		}
	}
}

/**
 * Asserts that the specified arguments is not null or undefined and throws an assertion error if it is.
 *
 * This is an assertion function and use of this function will impact TypeScript's flow analysis.
 */
export function assertNotNullish<T>(arg: T): asserts arg is NonNullable<T> {
	if (arg === null || arg === undefined) {
		throw new AssertionError(`Assertion Failure: The specified argument was null or undefined`);
	}
}
